import { createApp } from "vue";
import App from "../App.vue";

const app = createApp(App);

// import { logger } from '@/app/shared/services/app-logger/app-logger';

app.config.errorHandler = (err, vm, info) => {
  console.log({ err, vm, info });
};

window.onerror = function (message, source, lineno, colno, error) {
  console.log({ message, source, lineno, colno, error });
};
